<div class="sidebar-shell">
<div class="left-menu" [class.hover]="expandSidebar">
  <ngx-simplebar class="h-100" #componentRef>
    <div class="h-100 sidebar-menu">
      <div class="h-100 d-flex flex-column justify-content-between align-items-left">
        <ul>
          <li
            class="logo-menu-item"
            *ngIf="expandSidebar"
            role="button"
            tabindex="0"
            (click)="collapseSidebarFromLogo($event)"
            (keydown.enter)="collapseSidebarFromLogo($event)"
            (keydown.space)="collapseSidebarFromLogo($event)"
          ></li>
          <li *ngIf="!expandSidebar" class="collapse-menu-icon"
              (click)="toggleSidebar($event)" role="button" aria-label="Open menu">
            <img src="favicon.ico" alt="" class="img-fluid" width="25">
          </li>
          <ng-container *ngFor="let item of menuItems">
            <li *ngIf="shouldShowMenuItem(item)"
                (mouseenter)="onMenuItemHover(item, $event)"
                (mouseleave)="onMenuItemLeave()"
                (contextmenu)="onMenuContextMenu($event, item)">
              <a *ngIf="!item.hasExternalLink" class="menu-link" [href]="item.link"
                (click)="onInternalMenuClick($event, item)"
                [attr.aria-label]="item.label"
                [class.active]="item.label.toLowerCase().includes('chat') ? isChatRouteActive() : isCurrentRoute(item.link)">
                <img *ngIf="item.iconUrl" [src]="((item.label.toLowerCase().includes('chat') ? isChatRouteActive() : isCurrentRoute(item.link)) || isItemHovered(item)) ? item.activeIconUrl : item.iconUrl" alt=""
                  width="{{item.width}}">
                <span class="menu-label" *ngIf="expandSidebar"> {{ item.label }}</span>
              </a>
              <a *ngIf="item.hasExternalLink && item.appLicenseKey"
                 class="menu-link"
                 [class.disabled]="!availableLicenses?.includes(item.appLicenseKey)"
                 (click)="appClicked(item.appLicenseKey, availableLicenses?.includes(item.appLicenseKey))"
                 role="button"
                 [attr.aria-label]="item.label">
                <img *ngIf="item.iconUrl" [src]="isItemHovered(item) ? item.activeIconUrl : item.iconUrl" alt="" width="{{item.width}}">
                <span class="menu-label" *ngIf="expandSidebar"> {{ item.label }}</span>
              </a>
              <a *ngIf="item.hasExternalLink && !item.appLicenseKey && !item.label.toLowerCase().includes('engage')" class="menu-link" (click)="menuItemClicked(item)" role="button" [attr.aria-label]="item.label">
                <img *ngIf="item.iconUrl" [src]="isItemHovered(item) ? item.activeIconUrl : item.iconUrl" alt="" width="{{item.width}}">
                <span class="menu-label" *ngIf="expandSidebar"> {{ item.label }}</span>
              </a>
              <a *ngIf="item.hasExternalLink && item.label.toLowerCase().includes('engage')" 
                 class="menu-link" 
                 [class.disabled]="!availableLicenses.includes('engage')"
                 (click)="appClicked('engage', availableLicenses.includes('clinic'))" 
                 role="button"
                 [attr.aria-label]="item.label">
                <img *ngIf="item.iconUrl" [src]="isItemHovered(item) ? item.activeIconUrl : item.iconUrl" alt="" width="{{item.width}}">
                <span class="menu-label" *ngIf="expandSidebar"> {{ item.label }}</span>
              </a>
              <app-chat-history  *ngIf="item.label.toLowerCase().includes('chats') && expandSidebar" [showAllConversations]="false" (conversationSelected)="onConversationSelected($event)"></app-chat-history>
            </li>
          </ng-container>
        </ul>
        <ul class="sidebar-bottom-menu">
          <li
            class="my-apps-menu-item"
            (mouseenter)="onMenuItemHover(myAppsMenuItem, $event)"
            (mouseleave)="onMenuItemLeave()"
            (contextmenu)="onMenuContextMenu($event, myAppsMenuItem)"
          >
            <a
              class="menu-link"
              [href]="myAppsMenuItem.link"
              (click)="onInternalMenuClick($event, myAppsMenuItem)"
              [attr.aria-label]="myAppsMenuItem.label"
              [class.active]="isCurrentRoute(myAppsMenuItem.link)"
            >
              <img
                [src]="(isCurrentRoute(myAppsMenuItem.link) || isItemHovered(myAppsMenuItem)) ? myAppsMenuItem.activeIconUrl : myAppsMenuItem.iconUrl"
                alt=""
                [width]="myAppsMenuItem.width"
              >
              <span class="menu-label" *ngIf="expandSidebar">{{ myAppsMenuItem.label }}</span>
            </a>
          </li>
          <li class="user-menu-item">
            <button
              type="button"
              class="user-menu-trigger"
              aria-label="Account menu"
              [attr.aria-expanded]="showUserPopup"
              (click)="toggleUserPopup($event)"
            >
              <span class="user-avatar-trigger">
                <span class="user-avatar-trigger__initials">{{ currentUserInitials }}</span>
                <span class="user-avatar-trigger__status" aria-hidden="true"></span>
              </span>
              <span class="menu-label" *ngIf="expandSidebar">{{ currentUserName || 'Account' }}</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </ngx-simplebar>
  
  <!-- User account menu — HealthPay-style popover -->
  <div
    class="user-popup account-menu-popup"
    *ngIf="showUserPopup"
    role="menu"
    aria-label="Account menu"
    (click)="$event.stopPropagation()"
  >
    <div class="account-menu-profile">
      <div class="account-menu-avatar-wrap">
        <div class="account-menu-avatar">{{ currentUserInitials }}</div>
        <span class="account-menu-status-dot" aria-hidden="true"></span>
      </div>
      <div class="account-menu-details">
        <div class="account-menu-name">{{ currentUserName }}</div>
        <div class="account-menu-email" *ngIf="currentUserEmail">{{ currentUserEmail }}</div>
        <span class="account-menu-org-badge" *ngIf="currentCompanyName">{{ currentCompanyName }}</span>
      </div>
    </div>

    <div class="account-menu-divider" aria-hidden="true"></div>

    <div class="account-menu-actions">
      <button type="button" role="menuitem" class="account-menu-action" (click)="openSignatureModal()">
        <i class="fa-light fa-user account-menu-action__icon"></i>
        <span>Profile</span>
      </button>
      <button type="button" role="menuitem" class="account-menu-action" (click)="openDelegationsModal()">
        <i class="fa-light fa-users account-menu-action__icon"></i>
        <span>Delegations</span>
      </button>
      <button
        *ngIf="showCompanySwitch"
        type="button"
        role="menuitem"
        class="account-menu-action"
        (click)="gotoSelectCompanyPage()"
      >
        <i class="fa-light fa-building account-menu-action__icon"></i>
        <span>Switch organization</span>
      </button>
      <button type="button" role="menuitem" class="account-menu-action account-menu-action--signout" (click)="logout()">
        <i class="fa-light fa-arrow-right-from-bracket account-menu-action__icon"></i>
        <span>Sign out</span>
      </button>
    </div>
  </div>
</div>
<div
  class="sidebar-hover-tooltip"
  *ngIf="!expandSidebar && sidebarTooltipVisible && sidebarTooltipLabel"
  [style.top.px]="sidebarTooltipTop"
  role="tooltip"
>
  {{ sidebarTooltipLabel }}
</div>
</div>
